import { FaGithub, FaExternalLinkAlt } from 'react-icons/fa';
import styles from './ProjectCard.module.css';

function ProjectCard({ project }) {
  return (
    <div className={styles.card}>
      <h3 className={styles.title}>{project.title}</h3>
      <p className={styles.description}>{project.description}</p>
      
      <div className={styles.stack}>
        <strong>Stack:</strong>
        <div className={styles.stackList}>
          {project.stack.map((tech, index) => (
            <span key={index} className={styles.tech}>{tech}</span>
          ))}
        </div>
      </div>

      {(project.links.github || project.links.demo) && (
        <div className={styles.links}>
          {project.links.github && (
            <a 
              href={project.links.github} 
              target="_blank" 
              rel="noreferrer"
              className={styles.link}
            >
              <FaGithub /> View Code
            </a>
          )}
          {project.links.demo && (
            <a 
              href={project.links.demo} 
              target="_blank" 
              rel="noreferrer"
              className={styles.link}
            >
              <FaExternalLinkAlt /> Live Demo
            </a>
          )}
        </div>
      )}
    </div>
  );
}

export default ProjectCard;
